import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDanhMucKetQuaDanhGia } from '../../services/danhmuc';

const KetQuaDanhGiaSelectBox = ({ value, disabled, onChange, allowClear }: { value?: number, disabled?: boolean, onChange: (e: any) => void, allowClear?: boolean }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDanhMucKetQuaDanhGia(); 
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn kết quả đánh giá--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        name: name,
                        value: e
                    }
                })
            }}
            allowClear={allowClear}
            value={value}
            disabled={disabled}
        />
    );
};

export default KetQuaDanhGiaSelectBox;
